<template>
    <div class="plans_main admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="plans_selector">
            <b-dropdown :text="planName" no-caret>
                <b-dropdown-item v-on:click="onPlanChosen(item)" v-for="(item, index) in plans" :key="index">
                    <div class="plan_dropdown_item">
                    <div class="name">{{ item.name }}</div>
                    <div class="desc">{{ item.description }}</div>
                    </div>
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="input_block price">
            Price:
            <b-form-input
                v-model="price"
                placeholder="price"
                class="price_input"
            ></b-form-input>
        </div>
        <div class="currency_selector">
            <b-dropdown :text="currency" no-caret>
                <b-dropdown-item v-on:click="onCurrencyChosen(item)" v-for="(item, index) in currencies" :key="index">
                    <span>{{ item }}</span>
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="input_block tax">
            Tax %:
            <b-form-input
                v-model="tax"
                placeholder="tax %"
                class="tax_input"
            ></b-form-input>
        </div>
        <div class="input_block tax">
            Tag:
            <b-form-input
                v-model="tag"
                placeholder="for link, optional"
                class="tax_input"
            ></b-form-input>
        </div>
        <div class="input_block tax">
            Notes (optional):
            <b-form-input
                v-model="notes"
                placeholder="optional"
                class="tax_input"
            ></b-form-input>
        </div>
        <div class="input_block result_link" v-if="finalLink">
            Link to subscribe:
            <b-form-input
                v-model="finalLink"
                placeholder="Link to subscribe"
                class="result_link_input"
                disabled
            ></b-form-input>
        </div>
        <div class="main_btn" @click="onGeneratePlanClick()"><span>Generate link</span></div>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import customModalDialog from '@/components/widgets/customModalDialog';
import errorMixin from '@/mixins/errorMixin';
import uploadLandingFileDialog from '@/components/widgets/uploadLandingFileDialog';
import adminPageMixin from "@/mixins/adminPageMixin";


export default {
    name: 'subscriptions',
    mixins: [errorMixin, adminPageMixin,],
    components: {
        InfiniteLoading,
        customModalDialog,
        uploadLandingFileDialog,
    },

    data() {
        return {
            planName: 'Choose a plan',
            activePlan: null,
            plans: [],
            customModalSettings: {},
            price: 0,
            tax: 0,
            currency: 'USD',
            notes: '',
            tag: '',
            currencies: ['USD', 'EUR',],
            finalLink: '',
        }
    },

    props: [],

    watch: {},

    computed: {
        ...mapState({})
    },
    mounted() {
        this.initAdminPage()
        this.loadPlans()
    },
    methods: {

        ...mapActions({
            getActivePlans: 'payment/getActivePlans',
            createSubscription: 'payment/createSubscription',
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
            setProgressBarTag: 'setProgressBarTag',
        }),

        async onPlanChosen(plan) {
            this.planName = plan.name
            this.activePlan = plan
        },
        async onCurrencyChosen(currency) {
            this.currency = currency
        },

        async loadPlans() {
            this.setProgressBarTag({
                show: true,
                tag: 'load_plans'
            })
            try {
                const response = await this.getActivePlans()
                this.plans = response.plans
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'load_plans'
                })
            }
        },

        async onGeneratePlanClick() {
            this.finalLink = ''
            if(!this.activePlan) {
                this.showErrorModal('Please choose a plan')
                return
            }
            if(Number.parseFloat(this.price) == 0) {
                this.showErrorModal('Please enter price')
                return
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'create_sub'
                })
                const response = await this.createSubscription({
                    planId: this.activePlan.id,
                    data: {
                        price: Number.parseFloat(this.price),
                        tax: Number.parseFloat(this.tax),
                        currency: this.currency,
                        notes: this.notes,
                        tag: this.tag,
                    },
                })
                let tag = response.template.tag
                if(tag == null) {
                    tag = response.template.guid
                }
                this.finalLink = `https://my.air-vote.com/subscriptions/${encodeURIComponent(tag)}/pay`
                this.copyContent(this.finalLink, 'Link copied')
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'create_sub'
                })
            }
        },

        async copyContent(text, successText) {
            try {
                await navigator.clipboard.writeText(text);
                this.showErrorModal(successText || 'Content copied to clipboard')
                console.log(successText || 'Content copied to clipboard');
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        }

    }

}
</script>
<style>
.plans_main .dropdown .dropdown-menu.show {
    display: flex;
    flex-direction: column;
    width: 500px;
    max-width: 90vw;
}
</style>

<style scoped>
.plans_main {
    min-height: 80vh;
    padding: 16px;
    display: flex;
    flex-direction: column;
}

.plans_selector {
    width: 500px;
    max-width: 100%;
}

.plan_dropdown_item {
    display: flex;
    flex-direction: column;
    white-space: pre-wrap;
    max-width: 100%;
}
.plan_dropdown_item .name {
    font-size: 16px;
}
.plan_dropdown_item .desc {
    font-size: 13px;
    color: #616161;
    line-height: 14px;
}
.currency_selector {
    width: 300px;
    max-width: 100%;
    margin-top: 8px;
}
.input_block {
    max-width: 300px;
    margin-top: 12px;
}
.result_link {
    margin-top: 16px;
}

.main_btn {
    margin-top: 16px;
    background: #0e76a8;
    color: white;
    width: 200px;
    padding: 10px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
    cursor: pointer;
}
.main_btn:hover {
    background: #2D59A2;
}

.plans_main .dropdown /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-weight: 700;
    position: relative;
    padding: 5px 50px 5px 0;
    margin-left: 0;
    font-size: 16px;
    font-family: 'Nunito';
}

.plans_main .dropdown:before {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    content: " ";
    background: #3F405C;
    width: 100%;
    height: 1px;
}

.plans_main .dropdown:after {
    content: '';
    height: 7px;
    width: 7px;
    transform: rotate(45deg);
    right: 10px;
    top: 10px;
    position: absolute;
    border-bottom: 2px solid black;
    border-right: 2px solid black;
}

@media screen and (max-width: 402px) {
    .input_block {
        max-width: 100%;
    }
}

</style>
